import { Alert, Modal, tokens } from 'ComponentLibrary'
import { exportMissingAssetDataToExcel } from 'ClientPortal/src/pages/Assets/AssetList/ExportMissingData/exportMissingData'
import { useFetchValuationsForAssets } from 'ClientPortal/src/api/Queries/valuations'
import { useGetAssets } from 'ClientPortal/src/api/Queries/assets'
import { StyledLoadingDotsWrapper } from 'ComponentLibrary/src/atoms/LoadingIndicator/StyledLoadingDotsWrapper'
import { Box, Stack } from '@mui/material'
import { Typography } from 'ComponentLibrary/src/piazza'
import { getMissingDataExportCopy } from 'ClientPortal/src/pages/Assets/AssetList/ExportMissingData/constants'
import { isEmpty } from 'lodash'
import { useTranslation } from 'react-i18next'
import { useCurrentResolvedLocale } from 'ClientPortal/src/i18n/currentLocale'

type ExportMissingDataModalProps = {
    isOpen: boolean
    close: () => void
}
export const ExportMissingDataModal = ({ isOpen, close }: ExportMissingDataModalProps) => {
    const { t: tCommon } = useTranslation('terminology', { keyPrefix: 'common' })
    const { t: tExport } = useTranslation('terminology', { keyPrefix: 'export.missingData' })
    const locale = useCurrentResolvedLocale()
    const { assets, isAssetPending } = useGetAssets()
    const { mutateAsync: fetchAllValuations, isPending: isValuationsPending } = useFetchValuationsForAssets()
    const assetIds = assets.map((asset) => asset.uuid)
    const exportCopy = getMissingDataExportCopy({ tCommon, tExport, locale })

    const downloadMissingValue = async () => {
        const allValuations = await fetchAllValuations({ assetIds })
        const assetsWithValuations = assets
            .map((asset) => ({
                asset,
                valuations: allValuations.filter(({ asset_uuid }) => asset_uuid === asset.uuid),
            }))
            .filter(({ valuations }) => !isEmpty(valuations))
        await exportMissingAssetDataToExcel({ assetsWithValuations, copy: exportCopy, locale })
        close()
    }

    return (
        <Modal
            isOpen={isOpen}
            onClose={close}
            title={exportCopy.featureLabel}
            footerProps={{
                primaryButton: {
                    text: exportCopy.modalPrimaryActionLabel,
                    onClick: downloadMissingValue,
                    disabled: isAssetPending || isValuationsPending,
                },
                secondaryButton: { text: tCommon('confirmation.cancel'), onClick: close, disabled: isValuationsPending },
            }}
        >
            <Box position="relative" height="200px" width="100%">
                {isAssetPending || isValuationsPending ? (
                    <StyledLoadingDotsWrapper />
                ) : (
                    <Stack direction="column" gap={tokens.SizingSpacing300}>
                        <Typography variant="textM">{exportCopy.modalDescription}</Typography>
                        <Alert size="small" severity="info">
                            <Typography variant="textM" color={tokens.ColorTextBold}>
                                {exportCopy.modalDownloadInfo}
                            </Typography>
                        </Alert>
                    </Stack>
                )}
            </Box>
        </Modal>
    )
}
